import script from "./mobileFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobileFooter.vue?vue&type=script&setup=true&lang=ts"

import "./mobileFooter.vue?vue&type=style&index=0&id=1d292af2&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d292af2"]])

export default __exports__